import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);

  const refresh = async () => {
    try {
      const res = await api.get("/content");
      setContent(res.data);
    } catch (e) {
      console.error("content load failed", e);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ content, refresh, setContent }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
